import React from "react"
import Navbar from "../../components/navbar/Navbar"
import "./index.scss"
import { getFooterConfigObject, getMenuConfigObject } from "../../utils/graphqlUtils"
import { graphql } from "gatsby"
import { ImageHeader } from "../../components/imageHeader"
import { RichText } from "prismic-reactjs"
import { Footer } from "../../components/footer/Footer"
import { Divider } from "../../components/divider"
import { AppLink } from "../../components/appLink"
import ArrowRightButton from "../../images/arrow-right-rounded.png"
import desktopDelimiter from "../../images/delimiter_desktop.png"
import logo from "../../images/heidi-logo.png"
import mountains from "../../images/mountains.png"
import TemplateWrapper from "../../components/layout"

export const Careers = ({ data, pageContext, ...props }) => {

  const getCareerPageData = data && data.prismic && data.prismic.allCareers_pages && data.prismic.allCareers_pages.edges && data.prismic.allCareers_pages.edges[0].node

  const getAllCareers = data && data.prismic && data.prismic.allOpen_career_positions && data.prismic.allOpen_career_positions.edges

  return (
    <TemplateWrapper>
      <div id="careers">
        <Navbar {...props} menuObject={getMenuConfigObject(data)} data={data} pageContext={pageContext}/>
        {/*<div className="app-navbar-placeholder"/>*/}
        <div>
          <div className="d-block d-sm-none">
            <ImageHeader imgSrc={getCareerPageData?.header_image?.url}/>
            <div className="container text-center">
              {getCareerPageData && getCareerPageData.page_title && getCareerPageData.page_title[0] && RichText.render(getCareerPageData.page_title)}
              {getCareerPageData && getCareerPageData.page_description && getCareerPageData.page_description[0] &&
              <div className="pt-3">
                {RichText.render(getCareerPageData.page_description)}
              </div>}
              <Divider/>
            </div>
          </div>
          <div className="d-none d-sm-block">
            <section className="container-fluid p-0">
              <div className="row m-0">
                <div className="page-container d-flex position-relative">
                  <div className="desktop-left-section"
                       style={{ backgroundImage: `url('${getCareerPageData?.header_image?.url}')` }}>
                    <div className="desktop-section-delimiter"
                         style={{ backgroundImage: `url('${desktopDelimiter}')` }}/>
                  </div>
                  <div className="desktop-right-section d-flex flex-column align-items-center justify-content-center"/>
                  <div className="container position-absolute desktop-right-container p-0">
                    <div className="row justify-content-end">
                      <div className="col-6 p-0 text-center">
                        <div className="my-3">
                          <img className="img-fluid my-3" src={logo} width="75"/>
                          {getCareerPageData && getCareerPageData.page_title && getCareerPageData.page_title[0] && RichText.render(getCareerPageData.page_title)}
                          {getCareerPageData && getCareerPageData.page_description && getCareerPageData.page_description[0] &&
                          <div className="pt-3">
                            {RichText.render(getCareerPageData.page_description)}
                          </div>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div className="container text-center">
            <div className="w-sm-70">
              <img className="img-fluid d-none d-sm-block my-4" src={mountains} width="100" style={{ margin: "auto" }}/>
              {getCareerPageData && getCareerPageData.explore_section_title && getCareerPageData.explore_section_title[0] &&
              <div>{RichText.render(getCareerPageData.explore_section_title)}</div>
              }
              <Divider/>
              {getCareerPageData.job_listings_title && getCareerPageData.job_listings_title[0] &&
              <div>{RichText.render(getCareerPageData.job_listings_title)}</div>
              }
              {getAllCareers && getAllCareers.length > 0 && getAllCareers.filter((career => !career.node.disabled)).map((career, index) =>
                <div key={index.toString()} className="my-3">
                  <div className="job-title">
                    {career.node.job_title && career.node.job_title[0] && RichText.render(career.node.job_title)}
                  </div>
                  <div className="job-location pb-4">
                    {career.node.location && career.node.location.location_name}
                  </div>
                  {career.node.job_short_description && career.node.job_short_description[0] && RichText.render(career.node.job_short_description)}
                  <div className="go-to-button">
                    <AppLink to={`/${career?.node?._meta.uid}/#open-positions`} pageContext={pageContext}>
                      <img className="img-fluid" src={ArrowRightButton} width="40"/>
                    </AppLink>
                  </div>
                </div>
              )}
              <Divider/>
            </div>
          </div>
          <Footer data={getFooterConfigObject(data)}/>
        </div>
      </div>
    </TemplateWrapper>)
}

export default Careers

export const pageQuery = graphql`
    query CareersQuery($lang: String) {
        prismic {
            allCareers_pages(lang: $lang) {
                edges {
                    node {
                        header_image
                        page_title
                        page_description
                        explore_section_title
                        department_filter_label
                        location_filter_label
                        teams_filter_label
                        search_input_label
                        job_listings_title
                    }
                }
            }
            allMenus(lang: $lang) {
                edges {
                    node {
                        what_makes_heidi_unique_label
                        what_makes_heidi_unique_disabled
                        promo_campaign_label
                        promo_campaign_disabled
                        products_label
                        products_disabled
                        online_shop_label
                        online_shop_disabled
                        contact_disabled
                        chocolate_lover_disabled
                        contact_label
                        chocolate_lover_label
                        chocolate_label
                        chocolate_disabled
                        careers_label
                        careers_disabled
                        shops_page_label
                        shops_page_disabled
                    }
                }
            }
            allFooter_privacy_policy_linkss(lang: $lang) {
                edges {
                    node {
                        footer_privacy_policy_links {
                            link_title
                            link_resource {
                                ... on PRISMIC__FileLink {
                                    _linkType
                                    url
                                }
                            }
                        }
                    }
                }
            }
            allOpen_career_positions(lang: $lang, sortBy: meta_lastPublicationDate_ASC)  {
                edges {
                    node {
                        _meta {
                            uid
                            lang
                            lastPublicationDate
                        }
                        disabled
                        department {
                            ... on PRISMIC_Job_department {
                                name
                            }
                        }
                        location {
                            ... on PRISMIC_Job_location {
                                location_name
                            }
                        }
                        team {
                            ... on PRISMIC_Job_team {
                                team_name
                            }
                        }
                        job_title
                        job_short_description
                        job_long_description
                        responsibilities_title
                        responsibilities_description
                        requirements_title
                        requirements_description
                        benefits_title
                        benefits_description
                        upload_cv_button_link
                        upload_cv_button_text
                        linkedin_link {
                            ... on PRISMIC__ExternalLink {
                                _linkType
                                url
                            }
                        }
                        apply_on_linkedin_button_text
                    }
                }
            }
            allCookie_consents(lang: $lang) {
                edges {
                    node {
                        cookie_consent_text
                        cookie_consent_link {
                            ... on PRISMIC__ExternalLink {
                                url
                            }
                        }
                        cookie_consent_link_text
                        cookie_consent_button_text
                    }
                }
            }
        }
    }`
